import { render, staticRenderFns } from "./EzImageUpload.vue?vue&type=template&id=222792df&scoped=true&"
import script from "./EzImageUpload.vue?vue&type=script&lang=js&"
export * from "./EzImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./EzImageUpload.vue?vue&type=style&index=0&id=222792df&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222792df",
  null
  
)

export default component.exports